module.exports = __webpack_public_path__ + "assets/img/841587017535_.pic_hd.bd662026.jpg";